<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0" v-if="isBasic">
      <div class="title-text-official padding-b-19">选择购票方式</div>
      <CheckboxGroup v-model="methodGroup">
        <CellGroup>
          <Cell
            v-for="(item, index) in allMethodGrop"
            clickable
            :key="item"
            :title="`${item}`"
            @click="toggle(index)"
            ref="cells"
          >
            <template #icon>
              <img src="../../../../assets/img/h5/official/set_icon_jingjia_1.png" v-if="index == 0"/>
              <img src="../../../../assets/img/h5/official/set_icon_tehui_2.png" v-else-if="index == 1"/>
              <img src="../../../../assets/img/h5/official/set_icon_kuaisu_3.png" v-else-if="index == 2"/>
            </template>
            <template #right-icon>
              <Checkbox :name="item" ref="checkboxes" checked-color="#FF9934"/>
            </template>
          </Cell>
        </CellGroup>
      </CheckboxGroup>
      <div class="save-btn margin-t-45" @click="saveSet">
        确定保存
      </div>
    </div>
    <div class="padding-11-15 padding-b-0" v-if="!isBasic">
      <div class="title-text-official padding-b-19">基本设置</div>
      <van-tabs v-model="tabActive">
        <van-tab title="推广设置">
          <div class="method-group">
            <div class="method-group-title">购票方式</div>
            <CheckboxGroup v-model="methodGroup" direction="horizontal">
              <Checkbox v-for="(item, index) in allMethodGrop" :name="item" :key="index" checked-color="#FF9934">{{item}}</Checkbox>
            </CheckboxGroup>
          </div>
          <div class="field-list">
            <div class="field-box">
              <Field label="第1级代理分成" placeholder="请输入" v-model="promotionForm.percentOne">
                <template #right-icon>
                  <span>%</span>
                </template>
              </Field>
              <div class="field-tip"><span class="font-11">设置20%表示：您的利润分佣*20%即为一级推广者所得</span></div>
            </div>
            <div class="field-box">
              <Field label="第2级代理分成" placeholder="请输入" v-model="promotionForm.percentTwo">
                <template #right-icon>
                  <span>%</span>
                </template>
              </Field>
              <div class="field-tip"><span class="font-11">设置8%表示：您的利润分佣*20%即为二级推广者所得</span></div>
            </div>
            <div class="field-box">
              <Field label="总监提成" placeholder="请输入" v-model="promotionForm.percentMajor">
                <template #right-icon>
                  <span>%</span>
                </template>
              </Field>
              <div class="field-tip"><span class="font-11">设置50%表示：您的利润分佣扣除一二级代理，剩下的50%为总监分红。扣除一二级佣金和总监分红即为您的平台最终利润。总监用户身份设置请到“会员列表”用户信息详情页面设置</span></div>
            </div>
          </div>
          <div class="fixed-bottom" @click="handleSubmit('promotionForm')">
            <div class="save-btn margin-8-15">确定保存</div>
          </div>
        </van-tab>
        <van-tab title="提现设置">
          <div class="field-list">
            <div class="field-box">
              <Field label="最底提现金额" placeholder="请输入提现金额" v-model="withdrawForm.withdrawMin"></Field>
              <div class="field-tip"><span class="font-11">单笔提现大于最低提现金额才能提现。填写0表示不限制</span></div>
            </div>
            <div class="field-box">
              <Field label="提现为元的整数倍" placeholder="请输入提现金额" v-model="withdrawForm.withdrawPart"></Field>
              <div class="field-tip"><span class="font-11">填写0表示不限制</span></div>
            </div>
          </div>
<!--          <div class="withdraw-tip">-->
<!--            使用官方支付宝打款成功将收取<span style="color: #FF4F76;">1%</span>的手续费，提现金额和手续费从您的利润余额里扣除。请预留足够的余额，否则用户将提现失败。<span style="color: #999999;">有疑问请</span><span style="color: #FF4F76;" @click="getService">联系客服</span>-->
<!--          </div>-->
          <div class="fixed-bottom" @click="handleSubmit('withdrawForm')">
            <div class="save-btn margin-8-15">确定保存</div>
          </div>
        </van-tab>
        <van-tab title="邀请海报">
          <div class="title-text-official padding-t-20 padding-b-15">默认海报</div>
          <div class="poster-list">
            <CheckboxGroup v-model="userChoosePosterArr" direction="horizontal">
              <div class="poster-box" v-for="(item,index) of posterList" :key="index">
                <div class="poster-div">
                  <el-image
                    style="width: 150px; height: 266px"
                    :src="item.image"
                    fit="contain"></el-image>
                </div>
                <div class="radio-div">
                  <Checkbox :name="item.id" checked-color="#FF9934">启用</Checkbox>
                </div>
              </div>
            </CheckboxGroup>
          </div>
          <div class="fixed-bottom" @click="handleSubmit">
            <div class="save-btn margin-8-15">确定保存</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <Service ref="Service"></Service>
  </div>
</template>

<script>
import { getPlatformUuid, getIsBasic } from '@/utils/auth'
import { getServerConfig } from '@/api/user'
import Service from '@/views/h5/official/set/modal/Service'
import { CheckboxGroup, Checkbox, CellGroup, Cell, Icon, Tabs, Tab, Field } from 'vant'
import set from '@/javaApi/set'
const setModel = new set()
export default {
  name: 'Set',
  components: {
    CheckboxGroup,
    Checkbox,
    CellGroup,
    Cell,
    Icon,
    Tabs,
    Tab,
    Field,
    Service
  },
  data: function() {
    return {
      loading: false,
      selectIndex: 0,
      tabActive: 0,
      selectStyleObj: {
        background: "#FFFBF7",
        border: "1px solid #FF8622"
      },
      methodGroup: ['竞价购票', '特惠购票', '秒出票'],
      allMethodGrop: ['竞价购票', '特惠购票', '秒出票'],
      ticketTypeArr: [],
      promotionForm: {
        id: '',
        openCompete: 0,
        openDirect:0,
        openSoon:0,
        percentOne: '',
        percentTwo: '',
        percentMajor: '',
      },
      withdrawForm: {
        id: '',
        withdrawMin: '',
        withdrawPart: '',
        appid: '',
        alipayPublicKey: '',
        privateKey: '',
        readPublicKey: '',
        readPrivateKey: '',
        ticketType:''
      },
      percent:0,
      wechat_code: '',
      posterList: [],
      userChoosePosterArr: [

      ],
      selectIndexStr:'0,1',
      ajaxUploadUrl: 'http://127.0.0.1', //el-uploader 必填参数
      alipayCAPath: '',
      alipayPublicKeyPath: '',
      applicationRootPath: '',
      rootCert: '',
      certKeyRsa: '',
      appCert: ''
    }
  },
  computed: {
    alipayPublicKeyTip: function() {
      return (this.withdrawForm.alipayPublicKey) ? '参数已设置' : '参数未设置'
    },
    privateKeyTip: function() {
      return (this.withdrawForm.privateKey) ? '参数已设置' : '参数未设置'
    },
    platformUuid: function() {
      return getPlatformUuid()
    },
    isBasic: function() {
      return getIsBasic() === 'true' ? true : false
    },
    // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
    rootCertList: function() {
      if (this.rootCert) {
        return [{
          name: this.rootCert
        }]
      } else {
        return [

        ]
      }

    },
    appCertList: function() {
      if (this.appCert) {
        return [{
          name: this.appCert
        }]
      } else {
        return [

        ]
      }

    },
    certKeyRsaList: function() {
      if (this.certKeyRsa) {
        return [{
          name: this.certKeyRsa
        }]
      } else {
        return [

        ]
      }
    },
  },
  watch: {
    selectIndex: function() {
      this.initImgSrc()
    },
    methodGroup: function (){
      var ticketTypeArr = [];
      for (let i=0;i<this.allMethodGrop.length;i++){
        if(this.methodGroup.indexOf(this.allMethodGrop[i]) > -1){
          if(this.isBasic) {
            this.$refs.cells[i].style.backgroundColor = '#FFFBF7';
            this.$refs.cells[i].style.borderColor = '#FF8622';
          }
          ticketTypeArr.push(i)
        }else if(this.isBasic) {
          this.$refs.cells[i].style.backgroundColor = '#FFFFFF';
          this.$refs.cells[i].style.borderColor = '#E8E8E8';
        }
      }
      this.promotionForm.ticketType = ticketTypeArr.join(",");
    }
  },
  created: function() {
    this.getPromotionSet()
    this.getWithdrawSet()
    this.getPosterSet()
  },
  methods: {
    handlePublicKey(value) {
      this.withdrawForm.alipayPublicKey = value
    },
    handlePrivateKey(value) {
      this.withdrawForm.privateKey = value
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();

    },

    getPosterSet() {
      let that = this
      setModel.getPosterList({}).then(response => {
        let res = response.data
        if (res.code == 200) {
          that.posterList = res.data
          that.queryCheckPoster()
        } else {
          let message = response.message ? response.message : '系统异常请稍后再试'
          that.$message.error(message)
        }
      })
    },
    queryCheckPoster(){
      let that = this
      let param = {}
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        param.platformUuid =  this.platformUuid
      }
      setModel.getChoosedPoster(param).then(response => {
        let res = response.data
        if (res.code == 200) {
          if (res.data) {
            let possterArr = [];
            let i = 0;
            for (i; i < res.data.length; i++) {
              that.userChoosePosterArr[i] = res.data[i]['id']
            }
          }
        } else {
          let message = res.message ? res.message : '系统异常请稍后再试'
          that.$message.error(message)
        }
      }).catch(error => {
        that.$message.error('系统异常请稍后再试')
      })
    },
    initImgSrc: function() {
      this.selectImgObj = {
        biddingSrc: (this.promotionForm.openCompete == 1) ? biddingS : biddingN,
        preferentialSrc: (this.promotionForm.openDirect == 1) ? preferentialS : preferentialN,
        immediatelySrc: (this.promotionForm.openSoon  == 1) ? immediatelyS : immediatelyN
      }
    },
    selectMethod: function(selectIndex) {
      // selectIndex 0-竞价购票 1-特惠购票 2-秒出票
      let targetNum = parseInt(selectIndex)
      switch (targetNum) {
        case 0:
          this.promotionForm.openCompete = !this.promotionForm.openCompete
          break;
        case 1:
          this.promotionForm.openDirect = !this.promotionForm.openDirect
          break;
        default:
          this.promotionForm.openSoon = !this.promotionForm.openSoon
      }
    },
    getStyleObj:function (target) {
      // targe 0-竞价购票 1-特惠购票 2-秒出票
      let targetNum = parseInt(target)
      let isCheckStyle = false
      switch (targetNum) {
        case 0:
          isCheckStyle = this.promotionForm.openCompete
          break;
        case 1:
          isCheckStyle = this.promotionForm.openDirect
          break;
        default:
          isCheckStyle = this.promotionForm.openSoon
      }
      if(isCheckStyle){
        return this.selectStyleObj
      }else{
        return  ''
      }
    },
    getSelectImgSrc(target){
      // targe 0-竞价购票 1-特惠购票 2-秒出票
      let targetNum = parseInt(target)
      let condition = false
      let imgSrcObj
      switch (targetNum) {
        case 0:
          condition = this.promotionForm.openCompete
          if(condition){
            imgSrcObj = biddingS
          }else{
            imgSrcObj =  biddingN
          }
          break;
        case 1:
          condition = this.promotionForm.openDirect
          if(condition){
            imgSrcObj = preferentialS
          }else{
            imgSrcObj = preferentialN
          }
          break;
        default:
          condition = this.promotionForm.openSoon
          if(condition){
            imgSrcObj = immediatelyS
          }else{
            imgSrcObj = immediatelyN
          }
      }
      return  imgSrcObj
    },
    getImgObj(target){
      let targetNum = parseInt(target)
      let selectStyle;
      switch (targetNum) {
        case 0:
          selectStyle = this.promotionForm.openCompete
          break;
        case 1:
          selectStyle = this.promotionForm.openDirect
          break;
        case 2:
          selectStyle = this.promotionForm.openSoon
          break;
        default:
          selectStyle = false
      }
      if(selectStyle){
        return this.selectIcon
      }else{
        return this.unselectIcon
      }
    },
    saveSet: function() {
      if(this.platformUuid == '' || this.platformUuid == 0){
        this.$Message.error('请绑定公众号！')
        return
      }
      // let ticketArr = []
      // if(this.methodGroup){//if(this.promotionForm.openCompete){
      //   ticketArr.push(0)
      // }
      // if(this.promotionForm.openDirect){
      //   ticketArr.push(1)
      // }
      // if(this.promotionForm.openSoon){
      //   ticketArr.push(2)
      // }
      //
      // this.promotionForm.ticketType = ticketArr.join(',')
      setModel.savePromotionSet(this.promotionForm).then(response => {
        let res = response.data
        if (res.code == 200) {
          this.$Message.success('保存成功')
        } else {
          let message = res.message ? res.message : '系统繁忙请稍后再试！'
          this.$Message.error(message)
        }
      }).catch(error => {
        this.$Message.error('系统繁忙请稍后再试')
      })
    },
    changeTab: function(index) {
      this.tabActive = index;
    },
    handleSubmit: function(form) {
      if(this.platformUuid == '' || this.platformUuid == 0){
        this.$Message.error('请绑定公众号！')
        return
      }
      let validateRes = this.validateForm(form)
      let isValisdateSuccess = validateRes['is_success']
      if (isValisdateSuccess) {
        switch (form) {
          case 'promotionForm':
            this.promotionForm.platformUuid = this.platformUuid
            delete this.promotionForm.id
            setModel.savePromotionSet(this.promotionForm).then(response => {
              let res = response.data
              if (res.code == 200) {
                this.$Message.success('保存成功')
              } else {
                let message = res.message ? res.message : '系统繁忙请稍后再试！'
                this.$Message.error(message)
              }
            }).catch(error => {
              if(error != 'token invalid'){
                this.$Message.error('系统繁忙请稍后再试')
              }
            })
            break;
          case 'withdrawForm':
            // this.withdrawForm.certKeyRsa = (this.certKeyRsaList[0])?this.certKeyRsaList[0]['name']:''
            // this.withdrawForm.rootCert = (this.rootCertList[0])?this.rootCertList[0]['name']:''
            // this.withdrawForm.appCert = (this.appCertList[0])?this.appCertList[0]['name']:''
            let withdrawFormParam = this.formateInit(this.withdrawForm)
            delete  withdrawFormParam.certKeyRsa
            delete  withdrawFormParam.rootCert
            delete  withdrawFormParam.appCert
            withdrawFormParam.platformUuid = this.platformUuid
            delete  withdrawFormParam.id
            if(withdrawFormParam.value){
              delete  withdrawFormParam.value
            }
            // 暂时只传这两个
            withdrawFormParam = {
              withdrawMin:this.withdrawForm.withdrawMin,
              withdrawPart:this.withdrawForm.withdrawPart,
              platformUuid:this.platformUuid
            }
            setModel.saveWithdrawSet(withdrawFormParam).then(response => {
              let res = response.data
              if (res.code == 200) {
                this.$Message.success('保存成功')
              } else {
                let message = res.message ? res.message : '系统繁忙请稍后再试！'
                this.$Message.error(message)
              }
            }).catch(error => {
              if(error != 'token invalid'){
                this.$Message.error('系统繁忙请稍后再试')
              }
            })
            break;
          default:
            // 保存海报
            let param = {
              platformUuid: this.platformUuid,
              posterId: this.userChoosePosterArr.join(',')
            }
            setModel.setChoosePoster(param).then(response => {
              let res = response.data
              if (res.code == 200) {
                this.$Message.success('保存成功！')
              } else {
                let message = res.message ? res.message : '系统异常！请稍后再试'
                this.$Message.error(message)
              }
            }).catch(error => {
              if(error != 'token invalid'){
                this.$Message.error('系统繁忙请稍后再试')
              }
              console.log(error)
            })

        }
      } else {
        this.$Message.error(validateRes['tip'])
      }

    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    validateForm(form) {
      let res = {}
      switch (form) {
        case 'promotionForm':
          res = this.validatePromotionItem()
          break;
        case 'withdrawForm':
          res = this.validatewithdrawItem()
          break;
        default:
          res['is_success'] = true
          res['tip'] = '验证成功'
      }
      return res
    },
    validatePromotionItem() {
      let percentOne = this.promotionForm.percentOne
      if (!this.isNumber(percentOne)) {
        return {
          is_success: false,
          tip: '第一级代理分成请填写数字类型！'
        }
      }
      if (parseFloat(percentOne) < 0) {
        return {
          is_success: false,
          tip: '第一级代理分成请填大于等于0的数字'
        }
      }

      let percentTwo = this.promotionForm.percentTwo
      if (!this.isNumber(percentTwo)) {
        return {
          is_success: false,
          tip: '第二级代理分成请填写数字类型！'
        }
      }
      if (parseFloat(percentTwo) < 0) {
        return {
          is_success: false,
          tip: '第二级代理分成请填大于等于0的数字'
        }
      }

      let percentMajor = this.promotionForm.percentMajor
      if (!this.isNumber(percentMajor)) {
        return {
          is_success: false,
          tip: '总监分成分成请填写数字类型！'
        }
      }
      if (parseFloat(percentMajor) < 0) {
        return {
          is_success: false,
          tip: '总监分成请填大于等于0的数字'
        }
      }
      return {
        is_success: true,
        tip: '验证成功'
      }
    },
    validatewithdrawItem() {
      let withdrawMin = this.withdrawForm.withdrawMin
      if (!this.isNumber(withdrawMin)) {
        return {
          is_success: false,
          tip: '最低提现金额填写数字类型！'
        }
      }
      if (parseFloat(withdrawMin) < 0) {
        return {
          is_success: false,
          tip: '最低提现金额请填写大于等于0的数字！'
        }
      }
      this.withdrawForm.withdrawMin = parseFloat(withdrawMin)

      let withdrawPart = this.withdrawForm.withdrawPart
      if (!this.isNumber(withdrawPart)) {
        return {
          is_success: false,
          tip: '提现倍数请填写数字类型！'
        }
      }
      if (parseFloat(withdrawPart) < 0) {
        return {
          is_success: false,
          tip: '提现倍数请填写大于等于0的数字！'
        }
      }
      this.withdrawForm.withdrawPart = parseFloat(withdrawPart)
      if(this.withdrawForm.appid != ''){

        if(!this.withdrawForm.alipayPublicKey){
          //privateKey和alipayPublicKey
          return {
            is_success: false,
            tip: '请填写支付宝公钥！'
          }
        }

        if(!this.withdrawForm.privateKey){
          //privateKey和alipayPublicKey
          return {
            is_success: false,
            tip: '请填写应用私钥！'
          }
        }
      }
      return {
        is_success: true,
        tip: '验证成功'
      }
    },
    getPromotionSet: function() {
      let param = {}
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        param.platformUuid =  this.platformUuid
      }
      let that = this
      setModel.getPromotionSet(param).then(response => {
        let res = response.data
        if (res.code == 200) {
          //选中的推广方式
          that.methodGroup = []
          if (res.data && res) {
            let condition = (res.data)? (JSON.stringify(res.data) == "{}"):true
            if(!condition){
              that.promotionForm = res.data
            }

            let ticketArr = []
            if(this.promotionForm.openCompete){
              ticketArr.push(0)
            }
            if(this.promotionForm.openDirect){
              ticketArr.push(1)
            }
            if(this.promotionForm.openSoon){
              ticketArr.push(2)
            }
            let ticketType =   ticketArr.join(',')
            //this.promotionForm.ticketType = ticketType
            let platformUuid = (that.platformUuid == 0)?'':that.platformUuid
            if(ticketType == '' && platformUuid == ''){
              ticketType = '0,1'
            }
            that.selectIndexStr = ticketType
            let tempMethodGrop = ticketType.split(',')
            if (tempMethodGrop.length > 0) {
              let i;
              for (i = 0; i < tempMethodGrop.length; i++) {
                let tempIndex = tempMethodGrop[i]
                let tempLabel = that.allMethodGrop[tempIndex] ? that.allMethodGrop[tempIndex] : ''
                if (tempLabel) {
                  that.methodGroup.push(tempLabel)
                }
              }
            }
          }
        } else {
          let message = res.message ? res.message : '系统繁忙请稍后再试！'
          that.$Message.error(message)
        }
      })
        .catch(error => {
          console.log(error)
          if(error != 'token invalid'){
            that.$Message.error('系统繁忙请稍后再试')
          }
        })
    },
    getWithdrawSet: function() {
      let param = {}
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        param.platformUuid = this.platformUuid
      }

      let that = this
      setModel.getWithdrawSet(param).then(response => {
        let res = response.data
        if (res.code == 200) {
          if (res.data) {
            let conditionObj = ( res.data instanceof Object)
            let emptyObj = false
            let emptyArr = false
            let conditionArr = ( res.data instanceof Array)
            if(conditionObj){
              let dataInfo = res.data
              let arr = Object.keys(dataInfo);
              if(arr.length == 0){
                emptyObj = true
              }
            }
            if(conditionArr){
              if( res.data.length == 0){
                emptyArr = true
              }
            }
            if(!emptyObj && !emptyArr){
              that.withdrawForm = res.data
            }

            that.percent = res.data.value
            if (res.data.rootCert) {
              that.rootCert = res.data.rootCert
            }
            if (res.data.certKeyRsa) {
              that.certKeyRsa = res.data.certKeyRsa
            }
            if (res.data.appCert) {
              that.appCert = res.data.appCert
            }
          }
        } else {
          let message = res.message ? res.message : '系统繁忙请稍后再试！'
          that.$Message.error(message)
        }
      }).catch(error => {
        if(error != 'token invalid'){
          that.$Message.error('系统繁忙请稍后再试')
        }
      })
    },
    getService: function() {
      getServerConfig().then(response => {
        this.loading = false
        this.wechat_code = response.data.wechat_code
        this.$refs.Service.init(true, this.wechat_code)
      }).catch(error => {
        this.loading = false
        console.log(error)
        this.$Message.error('加载客服信息失败,请稍后再试!')
      })
    },
    isChecked: function(id) {
      let tempIndex = -1
      let i
      for (i = 0; i < this.userChoosePosterArr.length; i++) {
        if (this.userChoosePosterArr[i] == id) {
          tempIndex = i
          break;
        }
      }
      return (tempIndex >= 0)
    },
    setPrivateKey: function() {
      this.$refs.PrivateKey.init(true, this.withdrawForm)
    },
    setPublicKey: function() {
      this.$refs.PublicKey.init(true, this.withdrawForm)
    },
    choosePoster: function(id) {
      let i
      let tempIndex = -1
      for (i = 0; i < this.userChoosePosterArr.length; i++) {
        if (this.userChoosePosterArr[i] == id) {
          tempIndex = i
          break;
        }
      }
      if (tempIndex === -1) {
        this.userChoosePosterArr.push(id)
      } else {
        this.userChoosePosterArr.splice(tempIndex, 1)
      }
    },
    isNumber(num) {
      if (parseFloat(num).toString() == "NaN") {
        return false
      } else {
        return true;
      }
    },
    ajaxUploadCA(params) {
      // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('type', 'root')
      formData.append('platformUuid', that.platformUuid)
      setModel.uoloadFile(formData).then(response => {
        let res = response.data
        let message = res.message ? res.message : '系统异常，请稍后再试'
        if (res.success) {
          if (res.saveName) {
            that.alipayCAPath = res.saveName
          } else {
            that.$Message.error('上传失败！')
          }
        } else {
          that.$Message.error(message)
        }

      }).catch(error => {
        if(error != 'token invalid'){
          that.$Message.error('系统异常！请稍后再试！')
        }
      })

    },
    ajaxUploadAlipayPublic(params) {
      // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('type', 'rsa')
      formData.append('platformUuid', that.platformUuid)
      setModel.uoloadFile(formData).then(response => {
        let res = response.data
        let message = res.message ? res.message : '系统异常，请稍后再试'
        if (res.success) {
          if (res.saveName) {
            that.alipayPublicKeyPath = res.saveName
          } else {
            that.$Message.error('上传失败！')
          }
        } else {
          that.$Message.error(message)
        }

      }).catch(error => {
        if(error != 'token invalid'){
          that.$Message.error('系统异常！请稍后再试！')
        }
      })
    },
    ajaxBeforeUpload(){
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(condition){
        this.$Message.info('请先授权公众号再上传文件')
        return false
      }
    },
    ajaxBeforeUploadPublic() {
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(condition){
        this.$Message.info('请先授权公众号再上传文件')
        return false
      }
      if (this.rootCertList.length > 0) {
        this.$Message.info('最多只能上传一个文件，请移除文件列表里的文件')
        return false
      }
    },
    ajaxUploadApp(params) {
      // type 取值 rsa-支付宝公钥  root -支付宝ca app-应用公钥
      let that = this
      const formData = new window.FormData()
      formData.append('file', params.file)
      formData.append('type', 'app')
      formData.append('platformUuid', that.platformUuid)
      setModel.uoloadFile(formData).then(response => {
        let res = response.data
        let message = res.message ? res.message : '系统异常，请稍后再试'
        if (res.success) {
          if (res.filePath) {
            that.applicationRootPath = res.filePath
          } else {
            that.$Message.error('上传失败！')
          }
        } else {
          that.$Message.error(message)
        }

      }).catch(error => {
        if(error != 'token invalid'){
          this.$Message.error('系统异常！请稍后再试！')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.van-cell{
  font-family: Alibaba-PuHuiTi-R;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  align-items: center;
  img{
    width: 30px;
    margin-right: 10px;
  }
}

/deep/.van-cell__title{
  font-size: 14px;
  color: #666666;
}
/deep/.van-checkbox__icon{
  width: 22px;
  height: 22px;
}
/deep/.van-tabs__wrap{
  height: 32px;
  .van-tabs__nav{
    background: #EDEDED;
    border-radius: 16px;
    height: 32px;
    line-height: 32px;
    font-family: Alibaba-PuHuiTi-R;
    font-size: 12px;
    color: #666666;
  }
  .van-tabs__nav--line{
    padding: 0;
    .van-tab--active{
      height: 28px;
      background: #FFFFFF;
      border-radius: 14px;
      margin: 2px;
      color: #222222;
    }
  }
  .van-tabs__line{
    width: 0;
    height: 0;
  }
}
.method-group{
  display: flex;
  margin-top: 20px;
  .method-group-title{
    white-space: nowrap;
    font-size: 16px;
    color: #666666;
    margin-right: 22px;
  }
  /deep/.van-checkbox__label{
    margin: 0;
  }
}
.field-list{
  font-family: Alibaba-PuHuiTi-R;
  margin-top: 20px;
  margin-bottom: 56px;
  /deep/.van-cell{
    padding: 10px;
    background: #FAFAFA;
    border: 1px solid #EEEEEE;
    border-radius: 1px;
    margin-bottom: 0;
    .van-cell__title{
      font-size: 14px;
      color: #222222;
      white-space: nowrap;
    }
    .van-field__label{
      width: auto;
      margin-right: 10px;
    }
    .van-field__body{
      padding-left: 10px;
    }
    .van-field__control::-webkit-input-placeholder{
      color: #C1C1C1;
    }
    .van-cell__value::before{
      content: '';
      width: 1px;
      height: 12px;
      background: #E8E8E8;
      position: absolute;
      top: 50%;
      left:0;
      transform: translateY(-50%);
      -ms-transform: translateY(-50%);	/* IE 9 */
      -moz-transform: translateY(-50%); 	/* Firefox */
      -webkit-transform: translateY(-50%); /* Safari 和 Chrome */
      -o-transform: translateY(-50%); 	/* Opera */
    }
  }
  .field-tip{
    margin: 5px 0 15px;
    color: #999999;
  }
}
.withdraw-tip{
  padding: 10px 20px;
  font-size: 12px;
  color: #3D9EFC;
  text-align: justify;
  line-height: 17px;
  background: #F5F5F5;
  margin-left: -15px;
  position: fixed;
  bottom: 56px;
}
.poster-list{
  display: flex;
  margin-bottom: 56px;
  .poster-box {
    margin-right: 10px;
    .poster-div {
      margin-bottom: 7px;
    }
    .radio-div {
      display: flex;
      justify-content: center;
    }
  }
}
.van-checkbox-group--horizontal{
  overflow-y: auto;
}
.poster-list .van-checkbox-group--horizontal{
  flex-wrap: nowrap;
}
.poster-list .van-checkbox-group--horizontal::-webkit-scrollbar{
  display: none;
}
.save-btn{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #FFFFFF;
  background: #FF8622;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.fixed-bottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/set/Index.vue